import React from 'react';

const ArrowUpIcon = () => {
  return (
<svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.22595 3.82232L4.00358 1.46545L6.78121 3.82232C7.0604 4.05923 7.51141 4.05923 7.7906 3.82232C8.0698 3.58542 8.0698 3.20273 7.7906 2.96583L4.5047 0.177677C4.2255 -0.0592256 3.7745 -0.0592256 3.4953 0.177677L0.209396 2.96583C-0.0697985 3.20273 -0.0697985 3.58542 0.209396 3.82232C0.488591 4.05315 0.946756 4.05923 1.22595 3.82232Z" fill="white"/>
</svg>


  );
};

export default ArrowUpIcon;